import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { IOrder } from "../../stores/order";
import "./paginate.css";
import { useAuth } from "../../contexts/auth-context";

interface IPaginate {
  itemsPerPage: number;
  items: IOrder[];
  resetPage?: boolean;
  onPaginate: (orders: IOrder[], pageNo: number) => void;
}

const Paginate = ({
  items,
  itemsPerPage,
  resetPage,
  onPaginate,
}: IPaginate) => {
  const { isMobileResolution } = useAuth();
  const [currentPage, setCurrentPage] = useState(0);

  const pageCount = Math.ceil(items.length / itemsPerPage);

  useEffect(() => {
    resetPage && setCurrentPage(0);
  }, [resetPage]);

  useEffect(() => {
    const offset = currentPage * itemsPerPage;
    const currentItems = items.slice(offset, offset + itemsPerPage);
    onPaginate(currentItems, currentPage);
  }, [currentPage, items]);

  const handlePageChange = (e: { selected: number }) => {
    setCurrentPage(e.selected);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  };

  return (
    <div style={{ width: "90%", margin: "auto", textAlign: "center" }}>
      {items.length > 0 && (
        <ReactPaginate
          previousLabel={"Prev"}
          nextLabel={"Next"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={isMobileResolution ? 1 : 3}
          pageRangeDisplayed={isMobileResolution ? 1 : 3}
          onPageChange={handlePageChange}
          containerClassName={"pagination"}
          activeClassName={"active"}
          previousClassName={"prev"}
          nextClassName={"next"}
          disabledClassName={"disabled"}
          forcePage={currentPage}
        />
      )}
    </div>
  );
};

export default Paginate;
